import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    theme="light"
    className="toaster group"
    position="bottom-right"
    toastOptions={{
      classNames: {
        toast:
          'group toast group-[.toaster]:bg-white group-[.toaster]:text-ink group-[.toaster]:border group-[.toaster]:border-mist group-[.toaster]:shadow-panel group-[.toaster]:rounded-xl group-[.toaster]:font-sans',
        description: 'group-[.toast]:text-slate group-[.toast]:text-sm',
        actionButton: 'group-[.toast]:bg-accent group-[.toast]:text-white',
        cancelButton: 'group-[.toast]:bg-mist group-[.toast]:text-slate',
        success: 'group-[.toaster]:border-l-4 group-[.toaster]:border-l-emerald-500',
        error: 'group-[.toaster]:border-l-4 group-[.toaster]:border-l-alert',
        warning: 'group-[.toaster]:border-l-4 group-[.toaster]:border-l-amber-500',
        info: 'group-[.toaster]:border-l-4 group-[.toaster]:border-l-accent',
      },
    }}
    {...props}
  />
);

export { Toaster };
